export default __webpack_public_path__ + "static/media/Taskade.ac444bbc.png";